import { RECRUITMENT_TYPES, META_HTML_TITLE } from "@core/constants";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { LoadingManager } from "@core/managers/loading.manager";
import { ETAB_ROUTES, META_DASHBOARD_DETAIL_OPENED, META_DASHBOARD_SIDEMENU, META_DASHBOARD_TABS, META_MOBILE_NAVIGATION_TABS } from "@etab/config";
import { ACTION_EXTRA_GET_BY_ID } from "@etab/stores/types";
import { useExtraStore } from "@etab/stores/extra";

import PlanningPage from "./Planning.page.vue";
import PlanningMissionDetail from "./PlanningMission.detail.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.planning.root.path,
      name: ETAB_ROUTES.dashboard.planning.root.name,
      component: PlanningPage,
      meta: {
        [META_HTML_TITLE]: "ETAB.PAGES.PLANNING.@TITLE",
        [META_MOBILE_NAVIGATION_TABS]: true,
        [META_DASHBOARD_TABS]: true,
        [META_DASHBOARD_SIDEMENU]: true,
      },
      children: [
        {
          path: ETAB_ROUTES.dashboard.planning.mission.path,
          name: ETAB_ROUTES.dashboard.planning.mission.name,
          meta: { [META_DASHBOARD_DETAIL_OPENED]: true },
          components: {
            dashboardDrawer: PlanningMissionDetail,
          },
          async beforeEnter(to, from, next) {
            const extraStore = useExtraStore();
            try {
              LoadingManager.show();
              const demandId = to.params.missionId;
              const extraId = to.params.extraId;
              const type = RECRUITMENT_TYPES.TEMPORARY.shortLabel; // planning is only about TEMPORARY type
              await extraStore[ACTION_EXTRA_GET_BY_ID]({ extraId, demandId, type });
              next();
            } catch (error) {
              NotificationsManager.contactEtabSupport();
              // let's go back to planning in case of a problem
              next({ name: ETAB_ROUTES.dashboard.planning.root.name });
            } finally {
              LoadingManager.hide();
            }
          },
        },
      ],
    },
  ];
}
